import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { ComponentProps } from 'react';

import { mergeClasses } from '@/utils';

export const Separator = ({
  className,
  orientation = 'vertical',
  decorative = true,
  ...props
}: ComponentProps<typeof SeparatorPrimitive.Root>) => {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={mergeClasses('bg-neutral-3 shrink-0', className)}
      {...props}
    />
  );
};
